import { MindBoxSDK } from './api/mindBoxSDK'

export { updateMindbox } from './lib/updateMindbox'

export const mindBoxSDK = new MindBoxSDK()
